import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InventoryService } from '@services/inventory/inventory.service';
import { LoadingService } from '@services/loading/loading.service';
import { SettingService } from '@services/setting/setting.service';
import { SharedService } from '@services/shared/shared.service';
import { environment } from 'environments/environment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, fromEvent, Observable, of, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
  startWith,
  map,
  catchError,
  tap,
  throttleTime,
  takeUntil,
} from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { HttpClient } from '@angular/common/http';
import { IProductGroupData } from '@/typescript/interfaces/inventory.interface';
import { uniqueBy } from 'util/_helper';

interface Option {
  id: string;
  name: string;
  total_rows: number;
}

interface MenuItem {
  id: string;
  text: string;
  image: string;
  vin: string;
}

type TParams =
  | HttpParams
  | {
      [param: string]:
        | string
        | number
        | boolean
        | readonly (string | number | boolean)[];
    };

export interface Root {
  id: number;
  product_group_id: string;
  user_id: string;
  group_name: string;
  location: string;
  description: string;
  product_id: ProductId;
  created_at: string;
  updated_at: any;
  arabic_group_name: string;
  batch_used_in_auction: boolean;
  batchImageUrl: BatchImageUrl[];
  totalNoOfVehicles: number;
  totalSellingPrice: string;
}

export interface ProductId {
  '0': string;
  '1': string;
  '2': string;
  '3': string;
  '4': string;
  '5': string;
}

export interface BatchImageUrl {
  presigned_url: string;
  media_name: string;
  imageId: string;
}

@Component({
  selector: 'app-add-batch',
  templateUrl: './add-batch.component.html',
  styleUrls: ['./add-batch.component.scss'],
})
export class AddBatchComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('leftNonAddedProductList') leftNonAddedProductList: ElementRef;

  @ViewChild('rightNonAddedProductList') rightNonAddedProductList: ElementRef;

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger!: MatAutocompleteTrigger;

  @ViewChild('leftBox', { read: ElementRef })
  leftBox!: ElementRef<HTMLDivElement>;

  @ViewChild('rightBox', { read: ElementRef })
  rightBox!: ElementRef<HTMLDivElement>;

  private destroy$ = new Subject<void>();

  showItems = true;
  firstItemLoad = true;

  // dual-list custom

  leftItems: MenuItem[] = [];
  filteredPrevoiusLeftList: MenuItem[] = [];
  deletedLeftList: string[] = [];
  appenedLeftList: string[] = [];

  rightItems: MenuItem[] = [];
  filteredPrevoiusRightList: MenuItem[] = [];
  deletedRightList: string[] = [];
  appenedRightList: string[] = [];

  selectedLeft: MenuItem[] = [];
  selectedRight: MenuItem[] = [];

  // 🔹 Pagination state
  private pageItems = 1;
  private limitItems = 10;
  private searchTermItems = '';

  // 🔹 UI flags
  loadingItems = false;
  hasMoreItems = true;

  // 🔹 Pagination state
  private pageSelectedItems = 1;
  private limitSelectedItems = 10;
  private searchTermSelectedItems = '';

  // 🔹 UI flags
  loadingSelectedItems = false;
  hasMoreSelectedItems = true;

  // 🔹 Form control
  myControl = new FormControl({ value: '', disabled: true });

  vin1Control = new FormControl('');
  vin2Control = new FormControl({ value: '', disabled: true });

  // 🔹 Autocomplete data stream
  filteredOptions$: Observable<Option[]>;
  public optionsSubject = new BehaviorSubject<Option[]>([]);

  // 🔹 Pagination state
  private page = 1;
  private limit = 10;
  private searchTerm = '';

  // 🔹 UI flags
  loadingAutoComplete = false;
  private hasMore = true;

  public laddaLoading: boolean = false;
  public addBatchForm: FormGroup = this.formBuilder.group({
    name: ['', [Validators.required]],
    arabic_name: [''],
    location: ['', [Validators.required]],
    description: ['', [Validators.required]],
  });
  public submitted: boolean = false;
  public allListedProduct: any[] = [];
  public allSelectedProduct: any[] = [];
  public allSelectedListedProduct: any[] = [];
  public allSelectedproduct: any[] = [];
  public imageUrl: any;
  modalRef?: BsModalRef;
  public getImageInfo: any;
  public setIndex: any;
  public imageInfo: any;
  public setIndicator: boolean = false;
  public getGroupId: any;
  public loading: boolean = false;
  public env = environment.forntend_url;
  public imgBaseUrl = environment.imgBaseUrl;
  public envKeys = environment;
  public productDropDownList: any;
  public openListFlag: boolean = false;
  public attributeList: any[] = [];
  public onSearchKey: string = '';
  public showAlternateKey: boolean = false;
  public batchId: string = '';
  public cartTitle: string = '';
  public isUpdating: boolean = false;

  /* =======================
   RIGHT SIDE STATE
======================= */

  public onSearchKeyRight: string = '';
  public showAlternateKeyRight: boolean = false;

  public allListedProductRight: IProductGroupData[] = [];
  public showAllListedProductRight: boolean = false;
  public allSelectedListedProductRight: MenuItem[] = [];

  public searchParamsRight: string = '';
  public timerIdRight: NodeJS.Timeout;
  public isSearchingRight: boolean = false;

  /* =======================
   LEFT SIDE STATE
======================= */

  public attributeListLeft: any[] = [];
  public onSearchKeyLeft: string = '';
  public showAlternateKeyLeft: boolean = false;

  public allListedProductLeft: any[] = [];
  public showAllListedProductLeft: boolean = false;
  public allSelectedListedProductLeft: any[] = [];

  public searchParamsLeft: string = '';
  public timerIdLeft: NodeJS.Timeout;
  public isSearchingLeft: boolean = false;

  constructor(
    public formBuilder: FormBuilder,
    public inventoryService: InventoryService,
    public toastr: ToastrService,
    public router: Router,
    private modalService: BsModalService,
    public settingsService: SettingService,
    public loader: LoadingService,
    public sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        (this.allListedProductRight.length &&
          !this.rightNonAddedProductList.nativeElement.contains(e.target)) ||
        (this.allListedProductLeft.length &&
          !this.leftNonAddedProductList.nativeElement.contains(e.target))
      ) {
        console.log('click outside');
        setTimeout(() => {
          this.showAllListedProductRight = false;
          this.showAllListedProductLeft = false;
        }, 50);
      }
    });
  }

  ngOnInit(): void {
    const batchId = this.activatedRoute.snapshot.paramMap.get('batchId');

    if (batchId) {
      this.batchId = batchId;
      this.setEditBatchInfo(batchId);
      this.oneFetchProducts({
        productGroupId: batchId,
      });
      this.loadPage(this.searchTerm).subscribe();
    }

    this.getAttributeList();

    // list[0]?.addEventListener("")

    // Auto Complete

    this.optionsSubject.subscribe((options) => {
      if (options.length) {
        this.myControl.enable({ emitEvent: false });
        // this.autocompleteTrigger.openPanel();
      }
    });

    this.filteredOptions$ = this.optionsSubject.asObservable();

    this.myControl.valueChanges
      .pipe(
        debounceTime(300),

        // Always convert control value to string
        map((value) => (typeof value === 'string' ? value : value?.name ?? '')),

        tap((term) => {
          // 🔑 Reset pagination on new search
          this.searchTerm = term;
          this.page = 1;
          this.hasMore = true;
          this.loadingAutoComplete = false; // ✅ important
          this.optionsSubject.next([]);
          this.rightItems = [];
        }),
        switchMap((term) => this.loadPage(term))
      )
      .subscribe();

    this.vin1Control.valueChanges
      .pipe(
        debounceTime(300),

        // Always convert control value to string
        map((value) => (typeof value === 'string' ? value : value?.name ?? '')),

        tap((term) => {
          // 🔑 Reset pagination on new search
          this.searchTermItems = term;
          this.filteredPrevoiusLeftList = this.leftItems?.filter((_product) =>
            (_product?.['vin'] as string)
              ?.toLowerCase()
              ?.includes(term?.toLowerCase())
          );
          this.pageItems = 1;
          this.hasMoreItems = true;
          this.leftItems = [];
        })
      )
      .subscribe(() =>
        this.oneFetchProducts({
          productGroupId: batchId,
        })
      );

    this.vin2Control.valueChanges
      .pipe(
        debounceTime(300),

        // Always convert control value to string
        map((value) => (typeof value === 'string' ? value : value?.name ?? '')),

        tap((term) => {
          // 🔑 Reset pagination on new search

          this.searchTermSelectedItems = term;
          this.filteredPrevoiusRightList = this.rightItems?.filter((_product) =>
            (_product?.['vin'] as string)
              ?.toLowerCase()
              ?.includes(term?.toLowerCase())
          );
          this.pageSelectedItems = 1;
          this.hasMoreSelectedItems = true;
          this.rightItems = [];
        })
      )
      .subscribe(() =>
        this.oneFetchProducts({
          productGroupId: this.myControl.value?.['id'],
          forDestination: true,
        })
      );
  }

  ngAfterViewInit() {
    fromEvent(this.leftBox.nativeElement, 'scroll')
      .pipe(
        // throttleTime(50), // prevents rapid firing
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        console.log('addEventListener scroll leftBox');
        const { scrollTop, scrollHeight, clientHeight } =
          this.leftBox.nativeElement;

        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50; // 50px threshold

        console.log(this.hasMoreItems, 'this.hasMoreItems');

        if (isAtBottom && this.hasMoreItems && !this.loadingItems) {
          this.oneFetchProducts({
            productGroupId: this.batchId,
          });
        }
      });

    fromEvent(this.rightBox.nativeElement, 'scroll')
      .pipe(
        // throttleTime(50), // prevents rapid firing
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        console.log('addEventListener scroll rightBox');
        const { scrollTop, scrollHeight, clientHeight } =
          this.rightBox.nativeElement;

        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50; // 50px threshold

        if (
          isAtBottom &&
          this.hasMoreSelectedItems &&
          !this.loadingSelectedItems
        ) {
          this.oneFetchProducts({
            productGroupId: this.myControl.value.id,
            forDestination: true,
          });
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get formData() {
    return this.addBatchForm.controls;
  }

  // 🔹 Load one page from API
  public loadPage(term: string): Observable<Option[]> {
    if (!this.hasMore || this.loadingAutoComplete) {
      return of([]);
    }

    this.loadingAutoComplete = true;

    const params: TParams = {
      page: this.page,
      limit: this.limit,
    };

    if (term?.length) params.batchName = term;

    return this.inventoryService.getBatchList(params).pipe(
      tap((results) => {
        // console.log('loadPage_loadPage_loadPage_loadPage', {
        //   page: this.page,
        //   limit: this.limit,
        //   batchName: term,
        // });
        this.loadingAutoComplete = false;

        if (results?.[0]?.total_rows <= this.page * this.limit) {
          this.hasMore = false;
        }

        const current = this.optionsSubject.value;
        this.optionsSubject.next([...current, ...results]);
        // console.log(
        //   { current, results },
        //   'optionsSubject',
        //   this.optionsSubject.value
        // );
        this.page++;
      }),
      catchError((err) => {
        console.error('API error:', err);
        this.loading = false;
        return of([]);
      })
    );
  }

  /** API call */

  // onSearch(value: string) {
  //   console.log('INPUT:', value);
  //   this.searchSubject.next(value);
  // }

  // 🔹 Detect scroll inside autocomplete panel
  onOpened(): void {
    setTimeout(() => {
      const panel = document.querySelector('.mat-autocomplete-panel');
      if (!panel) return;

      panel.addEventListener('scroll', () => {
        const atBottom =
          panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 50;

        if (atBottom) {
          this.loadPage(this.searchTerm).subscribe();
        }
      });
    });
  }

  // 🔹 Display selected value in input
  displayFn(option: Option): string {
    return option ? option.name : '';
  }

  // 🔹 Handle option selection
  onOptionSelected(event: any): void {
    const selected: Option = event.option.value;

    // console.log(selected?.name, 'onOptionSelected', event.option.value);

    if (this.batchId === selected?.id) {
      this.toastr.error("Source and Destination Batch can't be same");
      setTimeout(() => {
        this.myControl.setValue(undefined);
      }, 50);
    } else {
      this.pageSelectedItems = 1;
      this.hasMoreSelectedItems = true;
      this.rightItems = [];

      this.oneFetchProducts({
        productGroupId: selected?.id,
        forDestination: true,
      });

      // Keep input searchable
      this.myControl.setValue(selected);
    }
  }

  oneFetchProducts({
    productGroupId,
    forDestination,
  }: {
    productGroupId: string;
    forDestination?: boolean;
  }) {
    this.showItems = false;
    if (forDestination) {
      this.loadingSelectedItems = true;
      this.selectedRight = [];
    } else {
      this.loadingItems = true;
      this.selectedLeft = [];
    }

    this.inventoryService
      .fetchProducts(productGroupId, {
        page: forDestination ? this.pageSelectedItems : this.pageItems,
        limit: forDestination ? this.limitSelectedItems : this.limitItems,
        vinNumber: forDestination
          ? this.searchTermSelectedItems
          : this.searchTermItems,
      })
      .subscribe((response) => {
        if (!this.leftItems?.length) this.firstItemLoad = false;

        if (forDestination) {
          this.vin2Control.enable({ emitEvent: false });

          if (
            +response?.data?.[0]?.total_rows <=
              this.pageSelectedItems * this.limit ||
            !response?.data?.length
          ) {
            this.hasMoreSelectedItems = false;
          }

          this.pageSelectedItems++;

          const itemList: MenuItem[] = response?.data
            ?.map((_product) => ({
              id: _product?.product_id,
              text: `${_product?.description_data?.['Model Year']} ${_product?.description_data?.['Make']} ${_product?.description_data?.['Model']} ${_product?.description_data?.['Trim/Type']}`,
              image: _product['vehicle_images']
                ? environment.imgBaseUrl +
                  _product['vehicle_images']?.['parts_images'].filter(
                    (part) => part.part_name === 'Front'
                  )?.[0]?.['image']
                : environment.forntend_url + 'assets/img/car-placeholder.png',
              vin: _product['description_data']['VIN Number'],
            }))
            .filter((_item) => !this.deletedRightList?.includes(_item?.id));

          let filteredAllSelectedListedProductRight = [];

          if (this.searchTermSelectedItems?.length) {
            filteredAllSelectedListedProductRight =
              this.allSelectedListedProductRight?.filter((_product) =>
                (_product?.['vin'] as string)
                  ?.toLowerCase()
                  ?.includes(this.searchTermSelectedItems?.toLowerCase())
              );
          }

          setTimeout(() => {
            this.loadingSelectedItems = false;
            this.rightItems = this.searchTermSelectedItems?.length
              ? uniqueBy(
                  [
                    ...itemList,
                    ...this.filteredPrevoiusRightList,
                    ...filteredAllSelectedListedProductRight,
                  ],
                  'id'
                )
              : uniqueBy(
                  [
                    ...this.filteredPrevoiusRightList,
                    ...this.allSelectedListedProductRight,
                    ...this.rightItems,
                    ...itemList,
                    ,
                  ],
                  'id'
                );

            console.log(this.rightItems, 'this.rightItems');
          }, 350);
        } else {
          if (
            +response?.data?.[0]?.total_rows <= this.pageItems * this.limit ||
            !response?.data?.length
          ) {
            this.hasMoreItems = false;
          }

          this.pageItems++;

          const itemList: MenuItem[] = response?.data
            ?.map((_product) => ({
              id: _product?.product_id,
              text: `${_product?.description_data?.['Model Year']} ${_product?.description_data?.['Make']} ${_product?.description_data?.['Model']} ${_product?.description_data?.['Trim/Type']}`,
              image: _product['vehicle_images']
                ? environment.imgBaseUrl +
                  _product['vehicle_images']?.['parts_images'].filter(
                    (part) => part.part_name === 'Front'
                  )?.[0]?.['image']
                : environment.forntend_url + 'assets/img/car-placeholder.png',
              vin: _product['description_data']['VIN Number'],
            }))
            .filter((_item) => !this.deletedLeftList?.includes(_item?.id));

          let filteredAllSelectedListedProductLeft = [];

          if (this.searchTermItems?.length) {
            filteredAllSelectedListedProductLeft =
              this.allSelectedListedProductLeft?.filter((_product) =>
                (_product?.['vin'] as string)
                  ?.toLowerCase()
                  ?.includes(this.searchTermItems?.toLowerCase())
              );
          }

          setTimeout(() => {
            this.loadingItems = false;
            this.leftItems = this.searchTermItems?.length
              ? uniqueBy(
                  [
                    ...itemList,
                    ...this.filteredPrevoiusLeftList,
                    ...filteredAllSelectedListedProductLeft,
                  ],
                  'id'
                )
              : uniqueBy(
                  [
                    ...this.filteredPrevoiusLeftList,
                    ...this.allSelectedListedProductLeft,
                    ...this.leftItems,
                    ...itemList,
                  ],
                  'id'
                );

            console.log(this.leftItems, 'this.leftItems');
          }, 350);
        }
        this.showItems = true;
      });
  }

  // delete from leftItems

  deleteLeftItem(_id: string) {
    this.leftItems = this.leftItems?.filter((_item) => _item?.id !== _id);

    this.deletedLeftList.push(_id);

    if (
      this.leftItems?.length <= 3 &&
      this.hasMoreItems &&
      !this.loadingItems
    ) {
      this.oneFetchProducts({
        productGroupId: this.batchId,
      });
    }
  }

  // delete from rightItems

  deleteRightItem(_id: string) {
    this.rightItems = this.rightItems?.filter((_item) => _item?.id !== _id);
    this.deletedRightList.push(_id);

    if (
      this.rightItems?.length <= 3 &&
      this.hasMoreSelectedItems &&
      !this.loadingSelectedItems
    ) {
      this.oneFetchProducts({
        productGroupId: this.myControl.value.id,
        forDestination: true,
      });
    }
  }

  // dual-list custom

  select(item: any, side: 'left' | 'right') {
    let list = side === 'left' ? this.selectedLeft : this.selectedRight;
    const index = list.indexOf(item);

    index === -1 ? list.push(item) : list.splice(index, 1);
  }

  moveSelected(to: 'left' | 'right') {
    const fromList = to === 'right' ? this.leftItems : this.rightItems;
    const fromDeletedList =
      to === 'right' ? this.deletedLeftList : this.deletedRightList;
    const toList = to === 'right' ? this.rightItems : this.leftItems;
    const toAppendList =
      to === 'right' ? this.appenedRightList : this.appenedLeftList;
    const selected = to === 'right' ? this.selectedLeft : this.selectedRight;
    console.log(this.selectedLeft, this.selectedRight, 'All moveSelected');

    selected.forEach((item) => {
      fromList.splice(fromList.indexOf(item), 1);
      fromDeletedList?.push(item?.id);
      toList.unshift(item);
      toAppendList.push(item?.id);
    });

    console.log('All Left', {
      list: this.leftItems,
      deleted: this.deletedLeftList,
      appened: this.appenedLeftList,
    });

    console.log('All Right', {
      list: this.rightItems,
      deleted: this.deletedRightList,
      appened: this.appenedRightList,
    });

    selected.length = 0;
  }

  moveAll(to: 'left' | 'right') {
    if (to === 'right') {
      this.rightItems.push(...this.leftItems);
      this.appenedRightList.push(...this.leftItems?.map((item) => item?.id));
      this.deletedLeftList.push(...this.leftItems?.map((item) => item?.id));
      console.log('All moveAll:', {
        right: this.rightItems,
        left: this.leftItems,
        appendR: this.appenedRightList,
        deleteL: this.deletedLeftList,
      });
      this.leftItems = [];
      this.selectedLeft = [];
    } else {
      this.leftItems.push(...this.rightItems);
      this.appenedLeftList.push(...this.rightItems?.map((item) => item?.id));
      this.deletedRightList.push(...this.rightItems?.map((item) => item?.id));
      console.log('All moveAll:', {
        right: this.rightItems,
        left: this.leftItems,
        appendL: this.appenedLeftList,
        deleteR: this.deletedRightList,
      });
      this.rightItems = [];
      this.selectedRight = [];
    }
  }

  onLotSubmit() {
    // const payload = {
    //   sourceGroupId: this.batchId,
    //   destinationProductGroupId: this.myControl.value.id ?? null,
    //   // sourceArray: this.leftItems?.map((_item) => _item?.id),
    //   // destinationArray: this.rightItems?.map((_item) => _item?.id),
    //   sourceAppendGroupArray: this.appenedLeftList,
    //   sourceDeleteGroupArray: this.deletedLeftList,
    //   destinationAppendGroupArray: this.appenedRightList,
    //   destinationDeleteGroupArray: this.deletedRightList,
    // };

    this.isUpdating = true;
    this.inventoryService
      .submitLot({
        sourceGroupId: this.batchId,
        destinationGroupId: this.myControl.value.id ?? null,
        // sourceArray: this.leftItems?.map((_item) => _item?.id),
        // destinationArray: this.rightItems?.map((_item) => _item?.id),
        sourceAppendGroupArray: this.appenedLeftList,
        sourceDeleteGroupArray: this.deletedLeftList,
        destinationAppendGroupArray: this.appenedRightList,
        destinationDeleteGroupArray: this.deletedRightList,
      })
      .subscribe(
        (res) => {
          if (res?.success) {
            this.isUpdating = false;
            this.toastr.success('Suceesfully Update the Lot');
            this.router.navigate(['/dashboard/inventory'], {
              queryParams: { type: 'batch', page: 1, limit: 10 },
            });
          }
        },
        () => {
          this.isUpdating = false;
          this.toastr.error('Something went wrong while updating the lot');
        }
      );
  }

  /**
   * Get all attribute list
   */

  getAttributeList() {
    this.settingsService.getProductAttributeList().subscribe(
      (res) => {
        let data = res['data'];
        for (let [index, item] of Object.entries(data)) {
          let attributes = item['field_name'];
          if (['VIN Number', 'Make', 'Model'].includes(attributes)) {
            this.attributeList.push(attributes);
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  /**
   * Select Search key and set it to global property
   */

  selectSearchOption(event: any) {
    this.onSearchKey = event.target.value;

    if (this.onSearchKey === 'VIN Number') {
      this.onSearchKey = this.onSearchKey.replace(' ', '_');
    } else {
      this.onSearchKey = this.onSearchKey.toLowerCase();
    }
    switch (this.onSearchKey) {
      case 'Model':
        this.showAlternateKey = false;
        break;
      default:
        this.showAlternateKey = true;
        break;
    }
    this.openproductlist();
  }

  // Right

  selectSearchOptionRight(event: any) {
    this.onSearchKeyRight = event.target.value;

    if (this.onSearchKeyRight === 'VIN Number') {
      this.onSearchKeyRight = this.onSearchKeyRight.replace(' ', '_');
    } else {
      this.onSearchKeyRight = this.onSearchKeyRight.toLowerCase();
    }

    switch (this.onSearchKeyRight) {
      case 'Model':
        this.showAlternateKeyRight = false;
        break;
      default:
        this.showAlternateKeyRight = true;
        break;
    }

    this.openproductlistRight();
  }

  // Left

  selectSearchOptionLeft(event: any) {
    this.onSearchKeyLeft = event.target.value;

    if (this.onSearchKeyLeft === 'VIN Number') {
      this.onSearchKeyLeft = this.onSearchKeyLeft.replace(' ', '_');
    } else {
      this.onSearchKeyLeft = this.onSearchKeyLeft.toLowerCase();
    }

    switch (this.onSearchKeyLeft) {
      case 'Model':
        this.showAlternateKeyLeft = false;
        break;
      default:
        this.showAlternateKeyLeft = true;
        break;
    }

    this.openproductlistLeft();
  }

  /**
   * Hide searchbar from html body
   */

  /**
   * Hide and Show the product list
   */

  public searchParams: string = '';
  public timerId: NodeJS.Timeout;
  public isSearching: boolean = false;

  openproductlist(event?: any, initialData?: boolean) {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    this.searchParams = event ? event.target?.value : this.searchParams;

    if (!this.searchParams || !this.onSearchKey) {
      return;
    }
    let searchProductInfo = {
      [this.onSearchKey]: this.searchParams,
    };

    this.timerId = setTimeout(() => {
      this.isSearching = true;
      this.inventoryService.searchProduct(searchProductInfo).subscribe(
        (res) => {
          this.allListedProduct = res['data']?.filter(
            (vehicle) => vehicle?.['type'] === '1'
          );

          this.allListedProduct.forEach((product, index) => {
            let frontImg = '';

            if (
              product?.['vehicle_images']?.['parts_images'] &&
              product['vehicle_images']['parts_images'].length
            ) {
              for (
                let i = 0;
                i < product['vehicle_images']['parts_images'].length;
                i++
              ) {
                if (
                  product['vehicle_images']['parts_images'][i]?.[
                    'part_name'
                  ] === 'Front'
                ) {
                  frontImg =
                    environment.imgBaseUrl +
                    product['vehicle_images']['parts_images'][i]['image'];
                  break;
                }
              }
            } else if (product?.['productImageUrl']?.[0]?.['presigned_url']) {
              frontImg = product['productImageUrl'][0]['presigned_url'];
            } else {
              frontImg = this.env + 'assets/img/car-placeholder.png';
            }

            this.allListedProduct[index].frontImg = frontImg;
          });

          this.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          this.isSearching = false;
          this.toastr.warning(error.statusText);
        }
      );
    }, 1000);
  }

  // Right

  openproductlistRight(event?: any) {
    if (this.timerIdRight) {
      clearTimeout(this.timerIdRight);
    }

    this.searchParamsRight = event
      ? event.target?.value?.trim()
      : this.searchParamsRight;

    // 🔴 RESET when input is empty
    if (!this.searchParamsRight || !this.onSearchKeyRight) {
      this.allListedProductRight = [];
      this.isSearchingRight = false;
      return;
    }

    const searchProductInfo = {
      [this.onSearchKeyRight]: this.searchParamsRight,
    };

    this.timerIdRight = setTimeout(() => {
      this.isSearchingRight = true;

      this.inventoryService.searchProduct(searchProductInfo).subscribe(
        (res) => {
          this.showAllListedProductRight = true;
          this.allListedProductRight =
            res?.['data']?.filter((vehicle) => vehicle?.type === '1') || [];

          const selectedIdsSet = new Set(
            this.allSelectedListedProductRight?.map((_product) => _product?.id)
          );

          this.allListedProductRight.forEach((product, index) => {
            let frontImg = this.env + 'assets/img/car-placeholder.png';

            if (product?.vehicle_images?.parts_images?.length) {
              const front = product.vehicle_images.parts_images.find(
                (p) => p.part_name === 'Front'
              );
              if (front?.image) {
                frontImg = environment.imgBaseUrl + front.image;
              }
            } else if (product?.productImageUrl?.[0]?.presigned_url) {
              frontImg = product.productImageUrl[0].presigned_url as string;
            }

            this.allListedProductRight[index].frontImg = frontImg;

            if (selectedIdsSet?.has(product?.product_id))
              product['added'] = true;
          });

          this.isSearchingRight = false;
        },
        () => {
          this.isSearchingRight = false;
        }
      );
    }, 600);
  }

  // Left

  openproductlistLeft(event?: any) {
    if (this.timerIdLeft) {
      clearTimeout(this.timerIdLeft);
    }

    this.searchParamsLeft = event
      ? event.target?.value?.trim()
      : this.searchParamsLeft;

    // 🔴 RESET when input is empty
    if (!this.searchParamsLeft || !this.onSearchKeyLeft) {
      this.allListedProductLeft = [];
      this.isSearchingLeft = false;
      return;
    }

    const searchProductInfo = {
      [this.onSearchKeyLeft]: this.searchParamsLeft,
    };

    this.timerIdLeft = setTimeout(() => {
      this.isSearchingLeft = true;

      this.inventoryService.searchProduct(searchProductInfo).subscribe(
        (res) => {
          this.showAllListedProductLeft = true;
          this.allListedProductLeft =
            res?.['data']?.filter((vehicle) => vehicle?.type === '1') || [];

          const selectedIdsSet = new Set(
            this.allSelectedListedProductLeft?.map((_product) => _product?.id)
          );

          this.allListedProductLeft.forEach((product, index) => {
            let frontImg = this.env + 'assets/img/car-placeholder.png';

            if (product?.vehicle_images?.parts_images?.length) {
              const front = product.vehicle_images.parts_images.find(
                (p) => p.part_name === 'Front'
              );
              if (front?.image) {
                frontImg = environment.imgBaseUrl + front.image;
              }
            } else if (product?.productImageUrl?.[0]?.presigned_url) {
              frontImg = product.productImageUrl[0].presigned_url;
            }

            this.allListedProductLeft[index].frontImg = frontImg;

            if (selectedIdsSet?.has(product?.product_id))
              product['added'] = true;
          });

          this.isSearchingLeft = false;
        },
        () => {
          this.isSearchingLeft = false;
        }
      );
    }, 600);
  }

  /**
   * Add Product through search dropdown
   */

  addProduct(batch: any) {
    const index = this.allSelectedListedProduct.findIndex(
      (vehicle) => vehicle?.['product_id'] === batch?.['product_id']
    );

    if (index === -1) {
      this.allSelectedListedProduct.push(batch);

      const filteredIndex = this.allListedProduct.findIndex(
        (vehicle) => vehicle?.['product_id'] === batch?.['product_id']
      );

      this.allListedProduct[filteredIndex]['added'] = true;
    }
  }

  // Right

  addProductRight(batch: any) {
    const index = this.allSelectedListedProductRight.findIndex(
      (vehicle) => vehicle?.['product_id'] === batch?.['product_id']
    );

    const selectedBatch = {
      id: batch?.product_id,
      text: `${batch?.description_data?.['Model Year']} ${batch?.description_data?.['Make']} ${batch?.description_data?.['Model']} ${batch?.description_data?.['Trim/Type']}`,
      image: batch['vehicle_images']
        ? environment.imgBaseUrl +
          batch['vehicle_images']?.['parts_images'].filter(
            (part) => part.part_name === 'Front'
          )?.[0]?.['image']
        : environment.forntend_url + 'assets/img/car-placeholder.png',
      vin: batch['description_data']['VIN Number'],
    };

    console.log(selectedBatch, 'batch addProductRight');

    if (index === -1) {
      this.allSelectedListedProductRight.unshift(selectedBatch);
      this.rightItems = uniqueBy(
        [...this.allSelectedListedProductRight, ...this.rightItems],
        'id'
      );
      this.appenedRightList = Array.from(
        new Set([
          ...this.allSelectedListedProductRight?.map(
            (_product) => _product?.id
          ),
          ...this.appenedRightList,
        ])
      );

      // if (this.myControl.value?.['id']) this.rightItems.push(selectedBatch);

      const filteredIndex = this.allListedProductRight.findIndex(
        (vehicle) => vehicle?.['product_id'] === batch?.['product_id']
      );

      if (filteredIndex !== -1) {
        this.allListedProductRight[filteredIndex]['added'] = true;
      }
    }
  }

  // Left

  addProductLeft(batch: any) {
    const index = this.allSelectedListedProductLeft.findIndex(
      (vehicle) => vehicle?.['product_id'] === batch?.['product_id']
    );

    const selectedBatch = {
      id: batch?.product_id,
      text: `${batch?.description_data?.['Model Year']} ${batch?.description_data?.['Make']} ${batch?.description_data?.['Model']} ${batch?.description_data?.['Trim/Type']}`,
      image: batch['vehicle_images']
        ? environment.imgBaseUrl +
          batch['vehicle_images']?.['parts_images'].filter(
            (part) => part.part_name === 'Front'
          )?.[0]?.['image']
        : environment.forntend_url + 'assets/img/car-placeholder.png',
      vin: batch['description_data']['VIN Number'],
    };

    console.log(selectedBatch, 'batch addProductLeft');

    if (index === -1) {
      this.allSelectedListedProductLeft.unshift(selectedBatch);

      this.leftItems = uniqueBy(
        [...this.allSelectedListedProductLeft, ...this.leftItems],
        'id'
      );

      this.appenedLeftList = Array.from(
        new Set([
          ...this.allSelectedListedProductLeft?.map((_product) => _product?.id),
          ...this.appenedLeftList,
        ])
      );

      const filteredIndex = this.allListedProductLeft.findIndex(
        (vehicle) => vehicle?.['product_id'] === batch?.['product_id']
      );

      if (filteredIndex !== -1) {
        this.allListedProductLeft[filteredIndex]['added'] = true;
      }
    }
  }

  /**
   * get all listed products
   */

  getAllListedProduct() {
    this.inventoryService.getAllAuctionVehicle().subscribe(
      (res) => {
        let data = res['data'];
        this.allListedProduct = data;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  /**
   * Selected Product
   */

  selectedItem(event: any, product_Id: any) {
    const index = this.allSelectedListedProduct.findIndex(
      (x) => x.product_id === product_Id
    );

    this.allSelectedListedProduct.splice(index, 1);
    this.toastr.success('Product Removed');

    const filteredIndex = this.allListedProduct.findIndex(
      (vehicle) => vehicle?.['product_id'] === product_Id
    );

    if (filteredIndex === -1) {
      return;
    }

    this.allListedProduct[filteredIndex]['added'] = false;
  }

  /**
   * Get Batch Image
   */

  getProfileImage(eve: Event, data: number) {
    if (eve.target['files'][0]['size'] > 5242880) {
      this.toastr.error('Image size should not be greater than 5MB');
    } else {
      let get_file = eve.target['files'][0];
      let fileTypeCheck: boolean =
        get_file.type == 'image/jpeg' ||
        get_file.type == 'image/png' ||
        get_file.type == 'image/jpg' ||
        get_file.type == 'image/webp';

      if (fileTypeCheck) {
        let reader: FileReader = new FileReader();
        reader.readAsDataURL(get_file);
        reader.onload = (eve) => {
          this.imageUrl = eve.target.result;
          this.imageInfo = {
            image: this.imageUrl,
            image_id: '',
          };
          this.toastr.success('Image upload successful');
        };
      } else {
        this.toastr.warning('Please use correct image format');
        return false;
      }
    }
  }

  /**
   * Create New Batch
   */

  addBatch() {
    this.submitted = true;
    this.laddaLoading = true;

    if (this.addBatchForm.invalid) {
      this.toastr.error('Invalid Form');
      return (this.laddaLoading = false);
    } else {
      var pattern = /^[a-zA-Z][a-zA-Z\s]*$/;
      var location = this.addBatchForm.get('location').value;

      if (location.match(pattern) == null) {
        this.toastr.error('Location should be only letters');
        this.laddaLoading = false;
        return;
      }
      this.createbatch(this.addBatchForm.value);
    }
  }

  createbatch(data: any) {
    //get product id list in format
    const formattedData = this.sharedService.getStrgObj(
      this.allSelectedListedProduct,
      'product_id'
    );

    if (
      formattedData['message'] === 'Minimum 2 vehicle need to create a batch'
    ) {
      return (this.laddaLoading = false);
    }

    // Data send to api
    let createBatchData = {
      batch: {
        group_name: data['name'],
        arabic_group_name: data['arabic_name'],
        location: data['location'],
        description: data['description'],
        product_id: JSON.parse(formattedData),
        file: this.imageInfo,
        product_group_id: this.batchId ? this.batchId : '',
      },
    };

    if (!this.imageInfo || this.imageInfo['image'] === '') {
      this.laddaLoading = false;
      return this.toastr.error('Please provide a image for this batch');
    }

    this.inventoryService.createBatch(createBatchData).subscribe(
      (res) => {
        this.toastr.success(res['message']);
        this.laddaLoading = false;
        this.router.navigate([`/dashboard/inventory`], {
          queryParams: {
            type: 'batch',
          },
        });
      },
      (error: HttpErrorResponse) => {
        this.toastr.error(error.error.errors);
        this.laddaLoading = false;
      }
    );
  }

  /**
   * Set Batch Data For Edit
   */

  setEditBatchInfo(batchId) {
    this.loading = true;
    this.allSelectedListedProduct = [];

    this.inventoryService.getBatchView(batchId).subscribe(
      (res: { data: object[]; message: string; success: boolean }) => {
        this.allSelectedListedProduct = res['data'].filter(
          (product) => product['description_data']
        );

        this.allSelectedListedProduct.forEach((product, index) => {
          let frontImg = '';

          if (
            product?.['vehicle_images']?.['parts_images'] &&
            product['vehicle_images']['parts_images'].length
          ) {
            for (
              let i = 0;
              i < product['vehicle_images']['parts_images'].length;
              i++
            ) {
              if (
                product['vehicle_images']['parts_images'][i]?.['part_name'] ===
                'Front'
              ) {
                frontImg =
                  environment.imgBaseUrl +
                  product['vehicle_images']['parts_images'][i]['image'];
                break;
              }
            }
          } else if (product?.['productImageUrl']?.[0]?.['presigned_url']) {
            frontImg = product['productImageUrl'][0]['presigned_url'];
          } else if (product?.['imageUrl']?.[0]?.['presigned_url']) {
            frontImg = product['imageUrl'][0]['presigned_url'];
          } else {
            frontImg = this.env + 'assets/img/car-placeholder.png';
          }

          this.allSelectedListedProduct[index].frontImg = frontImg;
        });

        // Set Batch Data
        const bathInfo = res['data'][0];

        let getImgelink = bathInfo['batchImageUrl'].length
          ? bathInfo['batchImageUrl']?.[0]?.['presigned_url']
          : null;
        this.getImageInfo = bathInfo['batchImageUrl']?.[0];
        this.getGroupId = bathInfo['product_group_id'];

        this.addBatchForm.get('name').setValue(bathInfo['group_name']);
        this.addBatchForm.get('location').setValue(bathInfo['location']);
        this.addBatchForm.get('description').setValue(bathInfo['description']);
        this.addBatchForm
          .get('arabic_name')
          .setValue(bathInfo['arabic_group_name']);
        this.addBatchForm.updateValueAndValidity();

        this.imageUrl = getImgelink;
        if (bathInfo['batchImageUrl'].length) {
          this.imageInfo = {
            image: this.getImageInfo['presigned_url'],
            image_id: this.getImageInfo['imageId'],
          };
        }

        this.loading = false;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  /**
   * Open Modal for delete Image
   */

  openModal(template: TemplateRef<any>, index: any) {
    this.modalRef = this.modalService.show(template);
    this.setIndex = index;
  }

  /**
   * Delete Batch Image
   */

  deleteImage(indicator: any) {
    this.setIndicator = indicator;

    this.imageUrl = '';
    this.imageInfo = {
      image: this.imageUrl,
      image_id: '',
    };

    let delete_info = {
      id: this.getGroupId,
      image_name: this.getImageInfo['media_name'],
      type: 'batch',
    };

    this.inventoryService.deleteProductImage(delete_info).subscribe(
      (res) => {
        this.toastr.success('Image Deleted');
        this.modalRef.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
      }
    );
  }

  public handleDismiss(dismissMethod: string): void {}
}
